if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });
        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }


      onSlideChanged(event) {
        const currentElement = event.detail.currentElement;
        if (!currentElement || !currentElement.dataset) {
          console.error(
            "Current element is undefined or does not have a dataset"
          );
          return; // Exit the function if currentElement is not valid
        }
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!activeMedia) return;
        const isMobile = window.innerWidth < 750;
        const mobileLayout = this.dataset.mobileLayout || "columns";

        // Remove active class from all media
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        // Add active class to current media
        activeMedia.classList.add("is-active");

        if (isMobile) {
          // Mobile-specific handling
          if (this.elements.viewer.slider) {
            const mainSlider = this.elements.viewer;
            const scrollOptions = {
              left: activeMedia.offsetLeft,
              behavior: "smooth",
            };
            mainSlider.querySelector(".slider").scrollTo(scrollOptions);

            // Handle thumbnails for mobile
            if (this.elements.thumbnails && mobileLayout !== "hide") {
              const activeThumbnail = this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );
              if (activeThumbnail) {
                // Update thumbnail selection
                this.elements.thumbnails
                  .querySelectorAll("button")
                  .forEach((button) => {
                    button.removeAttribute("aria-current");
                  });
                activeThumbnail
                  .querySelector("button")
                  .setAttribute("aria-current", true);

                // Scroll thumbnail into view
                this.elements.thumbnails.slider.scrollTo({
                  left: activeThumbnail.offsetLeft,
                  behavior: "smooth",
                });
              }
            }
          }
        } else {
          // Desktop handling
          if (prepend) {
            const shouldPrepend =
              activeMedia.parentElement.firstChild !== activeMedia;
            if (shouldPrepend) {
              activeMedia.parentElement.prepend(activeMedia);
              if (this.elements.thumbnails) {
                const activeThumbnail = this.elements.thumbnails.querySelector(
                  `[data-target="${mediaId}"]`
                );
                if (
                  activeThumbnail &&
                  activeThumbnail.parentElement.firstChild !== activeThumbnail
                ) {
                  activeThumbnail.parentElement.prepend(activeThumbnail);
                }
              }
            }
          }
        }

        // Reset slider if needed
        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }

        this.playActiveMedia(activeMedia);
        this.preventStickyHeader();

        // Update thumbnails
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );
          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(
              activeMedia,
              activeThumbnail.dataset.mediaPosition
            );
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
